import { render, staticRenderFns } from "./RangeTable.vue?vue&type=template&id=5c67316a&scoped=true&"
import script from "./RangeTable.vue?vue&type=script&lang=js&"
export * from "./RangeTable.vue?vue&type=script&lang=js&"
import style0 from "./RangeTable.vue?vue&type=style&index=0&id=5c67316a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c67316a",
  null
  
)

export default component.exports